import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import AuthService from '../services/AuthService';

interface NavbarProps {
  onLogout: () => void;
}

const NavContainer = styled.nav`
  background: #FFCC00;
  color: white;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const Logo = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  color: white;
`;

const NavActions = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

const DateTime = styled.div`
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 8px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 140px;
`;

const DateText = styled.span`
  color: #333;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const TimeText = styled.span`
  color: #222;
  font-size: 1rem;
  font-weight: 700;
  font-family: 'Courier New', monospace;
  margin-top: 2px;
`;

const LogoutButton = styled.button`
  background: #e74c3c;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    background: #c0392b;
  }
`;

const Navbar: React.FC<NavbarProps> = ({ onLogout }) => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDateTime = (date: Date) => {
    const dateStr = date.toLocaleDateString('es-ES', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
    
    const timeStr = date.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    
    return { dateStr, timeStr };
  };

  const handleLogout = () => {
    AuthService.logout();
    onLogout();
  };

  const { dateStr, timeStr } = formatDateTime(currentDateTime);

  return (
    <NavContainer>
      <Logo>SkyBot DHL</Logo>
      <NavActions>
        <DateTime>
          <DateText>{dateStr}</DateText>
          <TimeText>{timeStr}</TimeText>
        </DateTime>
        <LogoutButton onClick={handleLogout}>
          Cerrar Sesión
        </LogoutButton>
      </NavActions>
    </NavContainer>
  );
};

export default Navbar;
